import { BranchReferringParams } from "capacitor-branch-deep-links";

export const getPathFromReferringParams = (params: BranchReferringParams) => {
  if (params && params["+clicked_branch_link"]) {
    const path = params["$deeplink_path"];
    if (path) {
      return path.startsWith("/") ? path : `/${path}`;
    }
  }
  return null;
};
